"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterAdsByType = filterAdsByType;
exports.filterAdsByProjectId = filterAdsByProjectId;
exports.filterAdsBySearchOptions = filterAdsBySearchOptions;
exports.getReceiverAds = getReceiverAds;
exports.getSupplierAds = getSupplierAds;
exports.sortAdsByDate = sortAdsByDate;
exports.sortAdsByDeliveryStartDates = sortAdsByDeliveryStartDates;
exports.filterAdsByDeliveryDates = filterAdsByDeliveryDates;
exports.getThreeNewestAdsNotLoggedIn = getThreeNewestAdsNotLoggedIn;
exports.getThreeNewestAds = getThreeNewestAds;
exports.getSoilTypeName = getSoilTypeName;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterAdsByType(type, ads) {
  return ads.filter(function (ad) {
    return ad.ad_type === type;
  });
}

function getSoilTypeIds(props) {
  var ids = [];
  if (props.soil_type_id && props.soil_type_id.length) {
    props.soil_type_id.forEach(function (id) {
      if (id.value) {
        ids.push(parseInt(id.value));
      }
    });
  }
  return ids;
}

function getPostalAreas(props) {
  var postalAreas = [];
  if (props.postal_area && props.postal_area.length) {
    props.postal_area.forEach(function (area) {
      if (area.value) {
        postalAreas.push(area.value);
      }
    });
  }
  return postalAreas;
}
function filterAdsByProjectId(projectId, props, ads) {
  var adType = props.ad_type && props.ad_type.value;
  var soilTypeIds = getSoilTypeIds(props);
  var filteredAds = ads;

  filteredAds = ads.filter(function (ad) {
    return ad.project_id === projectId;
  });

  if (adType) {
    filteredAds = filteredAds.filter(function (ad) {
      return ad.ad_type === adType;
    });
  }

  if (soilTypeIds.length) {
    filteredAds = filteredAds.filter(function (ad) {
      return soilTypeIds.includes(ad.soil_type_id);
    });
  }

  return filteredAds;
}

function filterAdsBySearchOptions(props, ads, isPublic) {
  var adType = props.ad_type && props.ad_type.value;
  var postalAreas = getPostalAreas(props).map(function (area) {
    return area.toLowerCase();
  });
  var soilTypeIds = getSoilTypeIds(props);
  var filteredAds = ads;

  if (isPublic) {
    filteredAds = filteredAds.filter(function (ad) {
      return ad.project_id < 1;
    });
    //  filteredAds = filteredAds.filter((ad) => ad.visibility < 1);
  }

  if (adType) {
    filteredAds = filteredAds.filter(function (ad) {
      return ad.ad_type === adType;
    });
  }

  if (postalAreas.length) {
    filteredAds = filteredAds.filter(function (ad) {
      return postalAreas.includes(ad.postal_area.toLowerCase());
    });
  }

  if (soilTypeIds.length) {
    filteredAds = filteredAds.filter(function (ad) {
      return soilTypeIds.includes(ad.soil_type_id);
    });
  }

  return filteredAds;
}

function getReceiverAds(ads) {
  return filterAdsByType("receiverAd", ads);
}

function getSupplierAds(ads) {
  return filterAdsByType("supplierAd", ads);
}

function sortAdsByDate(ads) {
  return ads.sort(function (a, b) {
    return _moment2.default.utc(b.created_at).diff(_moment2.default.utc(a.created_at));
  });
}

function sortAdsByDeliveryStartDates(ads) {
  return _lodash2.default.orderBy(ads, ["delivery_start_date", "delivery_end_date"], ["asc", "asc"]);
  //  return ads.sort((a, b) => {
  //    return moment.utc(a.delivery_start_date).diff(moment.utc(b.delivery_start_date));
  //  });
}

function filterAdsByDeliveryDates(ads, startDate, endDate) {

  var isValidStartDate = (0, _moment2.default)(startDate, "MM/DD/YYYY", true).isValid();
  var isValidEndDate = (0, _moment2.default)(endDate, "MM/DD/YYYY", true).isValid();
  console.info("isValidStartDate", isValidStartDate);
  console.info("isValidEndDate", isValidEndDate);
  if (!isValidStartDate || !isValidEndDate) {
    return ads;
  }

  startDate = _moment2.default.utc(startDate);
  endDate = _moment2.default.utc(endDate);
  startDate.set({ h: 0, m: 0 });
  endDate.set({ h: 23, m: 59 });
  var filteredAds = ads.filter(function (ad) {
    return (0, _moment2.default)(ad.delivery_start_date) > startDate;
  });
  filteredAds = filteredAds.filter(function (ad) {
    return (0, _moment2.default)(ad.delivery_start_date) < endDate;
  });
  return sortAdsByDeliveryStartDates(filteredAds);
}

function getThreeNewestAdsNotLoggedIn(type, ads) {
  if (!ads || !ads.length) {
    return [];
  }
  var filteredAds = ads;

  filteredAds = filteredAds.filter(function (ad) {
    return ad.project_id < 1;
  });
  filteredAds = filteredAds.filter(function (ad) {
    return ad.visibility < 1;
  });

  return sortAdsByDate(filterAdsByType(type, filteredAds)).slice(0, 3);
}

function getThreeNewestAds(type, ads, companyId) {
  if (!ads || !ads.length) {
    return [];
  }

  var filteredAds = ads;
  filteredAds = filteredAds.filter(function (ad) {
    return ad.project_id < 1;
  });
  filteredAds = filteredAds.filter(function (ad) {
    return ad.visibility < 1 || ad.visibility == companyId;
  });

  return sortAdsByDate(filterAdsByType(type, filteredAds)).slice(0, 3);
}

function getSoilTypeName(ad, soilTypes) {
  var match = soilTypes.find(function (soilType) {
    return soilType.id === ad.soil_type_id;
  });
  if (match) {
    return match.name;
  }
  return "";
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/AdsUtil.js
 ** module id = 136
 ** module chunks = 0
 **/